import { markersV1 } from '@equiview/protocol';

/**
 * Estacao 2: os marcadores M1-M18, colados no lado esquerdo antes da foto de
 * perfil. Os angulos por fotogrametria dependem deles — marcador faltando e
 * angulo que nao sai da foto depois. Um toque marca "colado".
 */
export function MarcadoresDaEstacao2({
  marcadores,
  editavel,
  marcar,
}: {
  marcadores: Readonly<Record<string, boolean>>;
  editavel: boolean;
  marcar: (codigo: string, colado: boolean) => void;
}) {
  const colados = markersV1.filter((m) => marcadores[m.code]).length;
  return (
    <fieldset className="space-y-2">
      <legend className="flex w-full items-baseline justify-between text-sm font-medium">
        <span>Marcadores colados (lado esquerdo)</span>
        <span className={`numero text-xs ${colados === markersV1.length ? 'text-ok' : 'text-apagado'}`}>
          {colados}/{markersV1.length}
        </span>
      </legend>
      <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3 lg:grid-cols-6">
        {markersV1.map((m) => {
          const colado = marcadores[m.code] === true;
          return (
            <button
              key={m.code}
              type="button"
              aria-pressed={colado}
              disabled={!editavel}
              onClick={() => marcar(m.code, !colado)}
              title={m.label}
              className={`min-h-11 rounded-(--radius-controle) border px-2 py-1 text-left text-xs disabled:opacity-60 ${
                colado ? 'border-marca bg-marca text-sobre-marca' : 'border-borda-forte hover:border-destaque'
              }`}
            >
              <span className="font-mono font-semibold">{m.code}</span>
              <span className="block truncate opacity-80">{m.label}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
